import { ModalDialogContainer } from '@common/modal'
import {
  Alert,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@common/material'
import ClearIcon from '@mui/icons-material/Clear'
import React from 'react'
import { useModal } from '@common/GlobalModal'
import { localizedStrings } from '@core/strings'
import {
  RegisterItemPropertyFormItem,
  RegisterItemPropertyFormItemProps,
} from '@modules/registers/items/form'
import { FormProvider, useForm } from 'react-hook-form'
import { useToast } from '@core/toast'
import { useOverrideRegisterItemFormulaValue } from '@core/react-query/features/registers/registers/register/items/item/hooks/useOverrideRegisterItemFormulaValue'
import { Flex } from '@fundamentals'

type FormSchema = {
  [x: string]: string
}

export const RegisterItemOverrideFormulaModal: React.FC<
  RegisterItemPropertyFormItemProps
> = (props) => {
  const { hideModal } = useModal()
  const toast = useToast()

  const overrideRegisterItemFormulaValue = useOverrideRegisterItemFormulaValue()

  const defaultValues = props.registerTemplate.getDefaultFormValues(
    props.registerItem ? props.registerItem?.dataWithLinkProperties : [],
  )

  const formContext = useForm<FormSchema>({
    defaultValues,
  })

  const onSubmit = (data: FormSchema) => {
    const value = data[props.property.id]
    overrideRegisterItemFormulaValue.mutate(
      {
        registerId: props.register.id,
        registerItemId: props.registerItem.id,
        // @ts-ignore
        data: value,
      },
      {
        onSuccess: () => {
          hideModal()
          toast.success(localizedStrings.updated)
        },
        onError: (e) => {
          toast.error(e.message)
        },
      },
    )
  }

  return (
    <ModalDialogContainer>
      <DialogTitle
        variant='h5'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{ pr: 1, fontSize: 20 }}
      >
        {localizedStrings.overrideFormulaValue}
        <IconButton aria-label='close-modal' onClick={hideModal}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>
      <FormProvider {...formContext}>
        <form
          style={{
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
          onSubmit={formContext.handleSubmit(onSubmit)}
        >
          <DialogContent>
            <Alert sx={{ mb: 2 }} severity={'warning'}>
              {localizedStrings.overrideRegisterItemFormulaWarning}
            </Alert>
            <Flex>
              <RegisterItemPropertyFormItem
                key={props.property.id}
                property={props.property}
                register={props.register}
                registerItem={props.registerItem}
                registerTemplate={props.registerTemplate}
              />
            </Flex>
          </DialogContent>
          <DialogActions>
            <Button variant='outlined' onClick={hideModal}>
              {localizedStrings.cancel}
            </Button>
            <Button variant='contained' type='submit'>
              {localizedStrings.submit}
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </ModalDialogContainer>
  )
}
